<ion-header>
  <div class="left">
    <div class="back-button" (click)="onBackButtonClick()">
      <app-svg-icon [name]="'arrow-back'"></app-svg-icon>
    </div>
    <div class="title">
      {{ "@pages.imprint.header" | translate }}
    </div>
  </div>
</ion-header>
<div class="padding-md wrap">
  <div class="line">
    <div class="row-title">
      {{ "@pages.imprint.info.companyName.title" | translate }}
    </div>
    <div class="value">
      {{ appConfig.imprint.companyName[(langService.currentLang | async)!] }}
    </div>
  </div>

  <div class="line">
    <div class="row-title">
      {{ "@pages.imprint.info.address.title" | translate }}
    </div>
    <div class="value">
      {{ appConfig.imprint.companyAddress[(langService.currentLang | async)!] }}
    </div>
  </div>

  <div class="line">
    <div class="row-title">
      {{ "@pages.imprint.info.bulstat.title" | translate }}
    </div>
    <div class="value">
      {{ appConfig.imprint.bulstat }}
    </div>
  </div>

  <div class="line">
    <div class="row-title">
      {{ "@pages.imprint.info.taxNumber.title" | translate }}
    </div>
    <div class="value">
      {{ appConfig.imprint.taxNumber }}
    </div>
  </div>

  <div class="line">
    <div class="row-title">
      {{ "@pages.imprint.info.responsiblePerson.title" | translate }}
    </div>
    <div class="value">
      {{
        appConfig.imprint.responsiblePerson[(langService.currentLang | async)!]
      }}
    </div>
  </div>

  <div class="line">
    <div class="row-title">
      {{ "@pages.imprint.info.email.title" | translate }}
    </div>
    <div class="value">
      {{ appConfig.contactEmail }}
    </div>
  </div>

  <div class="line">
    <div class="row-title">
      {{ "@pages.imprint.info.phone.title" | translate }}
    </div>
    <div class="value">
      {{ appConfig.contactPhone | phone : "bg" }}
    </div>
  </div>

  <div class="line">
    <div class="row-title">
      {{ "@pages.imprint.info.website.title" | translate }}
    </div>
    <a href="{{ appConfig.imprint.coreWebsite }}" target="_blank" class="value">
      {{ appConfig.imprint.coreWebsite }}
    </a>
  </div>

  <div class="line">
    <div class="value">
      {{ "@pages.imprint.info.extraInfo" | translate }}
    </div>
  </div>
</div>
